import { gql } from '@apollo/client';

export const PATCH_CURRICULUM_MUTATION = gql`
    mutation patchCurriculum($input: CurriculumInput!) {
        result: patchCurriculum(input: $input) {
            id
            locales {
                locale
                name
                description
            }
            thumbnailImage {
                id
                name
                url
                __typename
            }
            heroImage {
                id
                name
                url
                __typename
            }
            courses {
                edges {
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                    }
                }
            }
            isPublic
            tags
            isSequential
            categoryIds
            segmentIds
            brandIds
            metadata
            createdAt
            updatedAt
        }
    }
`;
